<template>
  <div id="ly_itinerary_edit">
    <div class="page-header">
      <el-page-header @back="$router.back()" :content="isEdit ? '编辑行程模板' : '创建行程模板'" />
    </div>

    <el-form :model="form" :rules="rules" ref="templateForm" label-width="100px" class="edit-form">
      <el-card class="form-card" header="基本信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="模板名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入行程模板名称" maxlength="100" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="行程天数" prop="totalDays">
              <el-input-number v-model="form.totalDays" :min="1" :max="30" style="width:100%"
                @change="onDaysChange" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板描述">
              <el-input v-model="form.description" type="textarea" :rows="2" placeholder="请输入模板描述" maxlength="500" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card class="form-card" header="行程节点">
        <div v-for="day in form.totalDays" :key="day" class="day-section">
          <div class="day-title">
            <span>第 {{ day }} 天</span>
            <el-button type="text" size="mini" @click="addNode(day)">+ 添加节点</el-button>
          </div>
          <div v-if="getNodesByDay(day).length === 0" class="day-empty">暂无节点，点击右侧「添加节点」</div>
          <div v-for="node in getNodesByDay(day)" :key="node._key" class="node-item">
            <div class="node-header">
              <el-tag size="mini" :type="nodeTypeMap[node.nodeType] && nodeTypeMap[node.nodeType].tag">
                {{ nodeTypeMap[node.nodeType] ? nodeTypeMap[node.nodeType].label : '未设置' }}
              </el-tag>
              <span class="node-name">{{ node.name || '（未命名节点）' }}</span>
              <div class="node-actions">
                <el-button type="text" size="mini" @click="editNode(node)">编辑</el-button>
                <el-button type="text" size="mini" style="color:#F56C6C" @click="removeNode(node)">删除</el-button>
              </div>
            </div>
            <div class="node-meta">
              <span v-if="node.startTime">{{ node.startTime }}{{ node.endTime ? ' - ' + node.endTime : '' }}</span>
              <span v-if="node.description" style="margin-left:12px;color:#909399">{{ node.description }}</span>
            </div>
          </div>
        </div>
      </el-card>

      <div class="form-footer">
        <el-button @click="$router.back()">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </div>
    </el-form>

    <!-- 节点编辑弹窗 -->
    <el-dialog title="节点信息" :visible.sync="nodeDialogVisible" width="540px">
      <el-form :model="nodeForm" :rules="nodeRules" ref="nodeFormRef" label-width="90px">
        <el-form-item label="节点类型" prop="nodeType">
          <el-radio-group v-model="nodeForm.nodeType">
            <el-radio-button v-for="(v, k) in nodeTypeMap" :key="k" :label="Number(k)">{{ v.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="节点名称" prop="name">
          <el-input v-model="nodeForm.name" placeholder="请输入节点名称" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-time-select v-model="nodeForm.startTime" :picker-options="{ start:'00:00', step:'00:30', end:'23:30' }"
                placeholder="开始时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-time-select v-model="nodeForm.endTime" :picker-options="{ start:'00:00', step:'00:30', end:'23:30' }"
                placeholder="结束时间" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="nodeForm.nodeType === 2" label="操作类型">
          <el-radio-group v-model="nodeForm.hotelActionType">
            <el-radio :label="1">入住</el-radio>
            <el-radio :label="2">退房</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="节点描述">
          <el-input v-model="nodeForm.description" type="textarea" :rows="2" placeholder="节点描述" maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="nodeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveNode">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let keyCounter = 0;
export default {
  name: "ly_itinerary_edit",
  data() {
    return {
      loading: false,
      nodeDialogVisible: false,
      form: {
        id: null,
        name: "",
        totalDays: 1,
        description: "",
        status: 1,
        nodes: [],
      },
      nodeForm: this.initNodeForm(1),
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        totalDays: [{ required: true, message: "请输入行程天数", trigger: "blur" }],
      },
      nodeRules: {
        nodeType: [{ required: true, message: "请选择节点类型", trigger: "change" }],
        name: [{ required: true, message: "请输入节点名称", trigger: "blur" }],
      },
      nodeTypeMap: {
        1: { label: "接送", tag: "success" },
        2: { label: "酒店", tag: "warning" },
        3: { label: "景区", tag: "danger" },
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.query.id;
    },
  },
  created() {
    if (this.isEdit) {
      this.loadTemplate();
    }
  },
  methods: {
    initNodeForm(day) {
      return { _key: ++keyCounter, _isEdit: false, dayNo: day, sortNo: 0, nodeType: 1, name: "", startTime: "", endTime: "", description: "", hotelActionType: null, travelLineId: null, hotelId: null, scenicId: null };
    },
    async loadTemplate() {
      let { code, data } = await this.$axios.get(`/api/v1/manage/travelItinerary/${this.$route.query.id}`);
      if (code === 1 && data) {
        this.form.id = data.id;
        this.form.name = data.name;
        this.form.totalDays = data.totalDays;
        this.form.description = data.description;
        this.form.status = data.status;
        this.form.nodes = (data.nodes || []).map(n => ({ ...n, _key: ++keyCounter, _isEdit: false }));
      }
    },
    getNodesByDay(day) {
      return this.form.nodes.filter(n => n.dayNo === day).sort((a, b) => a.sortNo - b.sortNo);
    },
    onDaysChange(newVal) {
      this.form.nodes = this.form.nodes.filter(n => n.dayNo <= newVal);
    },
    addNode(day) {
      this.nodeForm = this.initNodeForm(day);
      this.nodeForm._isEdit = false;
      this.nodeDialogVisible = true;
      this.$nextTick(() => this.$refs.nodeFormRef && this.$refs.nodeFormRef.clearValidate());
    },
    editNode(node) {
      this.nodeForm = { ...node, _isEdit: true };
      this.nodeDialogVisible = true;
      this.$nextTick(() => this.$refs.nodeFormRef && this.$refs.nodeFormRef.clearValidate());
    },
    saveNode() {
      this.$refs.nodeFormRef.validate((valid) => {
        if (!valid) return;
        if (this.nodeForm._isEdit) {
          const idx = this.form.nodes.findIndex(n => n._key === this.nodeForm._key);
          if (idx !== -1) this.$set(this.form.nodes, idx, { ...this.nodeForm });
        } else {
          const dayNodes = this.getNodesByDay(this.nodeForm.dayNo);
          this.nodeForm.sortNo = dayNodes.length + 1;
          this.form.nodes.push({ ...this.nodeForm });
        }
        this.nodeDialogVisible = false;
      });
    },
    removeNode(node) {
      this.form.nodes = this.form.nodes.filter(n => n._key !== node._key);
    },
    submitForm() {
      this.$refs.templateForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const payload = {
            ...this.form,
            nodes: this.form.nodes.map(({ _key, _isEdit, ...rest }) => rest),
          };
          let url = "/api/v1/manage/travelItinerary";
          let { code } = this.isEdit
            ? await this.$axios.put(url, payload)
            : await this.$axios.post(url, payload);
          if (code === 1) {
            this.$message.success(this.isEdit ? "修改成功" : "创建成功");
            this.$router.push({ path: "/travelItineraryTemplate" });
          }
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#ly_itinerary_edit {
  padding: 16px;
  .page-header { margin-bottom: 16px; }
  .form-card { margin-bottom: 16px; }
  .edit-form { max-width: 900px; }
  .form-footer { text-align: center; padding: 20px 0; }

  .day-section {
    margin-bottom: 20px;
    .day-title {
      display: flex; align-items: center; justify-content: space-between;
      font-size: 14px; font-weight: 600; color: #303133;
      padding: 8px 0; border-bottom: 1px solid #EBEEF5; margin-bottom: 10px;
    }
    .day-empty { color: #C0C4CC; font-size: 13px; text-align: center; padding: 12px 0; }
    .node-item {
      border: 1px solid #EBEEF5; border-radius: 4px; padding: 10px 14px; margin-bottom: 8px;
      background: #FAFAFA;
      .node-header {
        display: flex; align-items: center; gap: 8px;
        .node-name { flex: 1; font-size: 13px; color: #303133; }
        .node-actions { display: flex; gap: 4px; }
      }
      .node-meta { margin-top: 4px; font-size: 12px; color: #909399; }
    }
  }
}
</style>
